import { render } from "./AppDate.vue?vue&type=template&id=8abd8d38"
import script from "./AppDate.vue?vue&type=script&lang=js"
export * from "./AppDate.vue?vue&type=script&lang=js"
script.render = render

export default script